/** Cognito user attribute name mapping. */
export const COGNITO_ATTRIBUTES = {
  givenName: 'given_name',
  familyName: 'family_name',
  betaAccess: 'custom:beta_access',
  edgeUserId: 'custom:edge_user_id',
  migrationStage: 'custom:migration_stage',
} as const
